import { IconName } from '@ardoq/icons';
import { type OnViewSettingsUpdate } from '@ardoq/data-model';
import { SettingsType, type ToggleConfig } from '@ardoq/view-settings';
import { SHOW_ONLY_CONNECTED_COMPONENTS } from '@ardoq/global-consts';

export const showOnlyConnectedComponents = (
  showOnlyConnectedComponents: boolean,
  onViewSettingsUpdate: OnViewSettingsUpdate
): ToggleConfig => ({
  id: 'showOnlyConnectedComponents',
  label: SHOW_ONLY_CONNECTED_COMPONENTS,
  iconName: IconName.LINK,
  isActive: showOnlyConnectedComponents,
  type: SettingsType.TOGGLE,
  onViewSettingsUpdate,
});
